/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_VideoInputs */



/**
* | output |
* | --- |
* | "Video" |
*
* @param {Preset_Manager_Tab_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_video = /** @type {((inputs?: Preset_Manager_Tab_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vídeo")
	return /** @type {LocalizedString} */ ("Video")
});